import React from 'react';

import Icon from '../Icon';

export const VibrationIntensityHighIcon = (props) => {
    return (
        <Icon width='48' height='48' viewBox='0 0 32 32' fill='none' {...props}>
            <path
                d='M6.40041 12.4448H5.6893C5.49293 12.4448 5.33374 12.604 5.33374 12.8004V19.2004C5.33374 19.3967 5.49293 19.5559 5.6893 19.5559H6.40041C6.59677 19.5559 6.75596 19.3967 6.75596 19.2004V12.8004C6.75596 12.604 6.59677 12.4448 6.40041 12.4448Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M26.3115 12.4448H25.6004C25.4041 12.4448 25.2449 12.604 25.2449 12.8004V19.2004C25.2449 19.3967 25.4041 19.5559 25.6004 19.5559H26.3115C26.5079 19.5559 26.6671 19.3967 26.6671 19.2004V12.8004C26.6671 12.604 26.5079 12.4448 26.3115 12.4448Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M11.3782 8.17773H10.6671C10.4707 8.17773 10.3115 8.33692 10.3115 8.53329V23.4666C10.3115 23.663 10.4707 23.8222 10.6671 23.8222H11.3782C11.5746 23.8222 11.7337 23.663 11.7337 23.4666V8.53329C11.7337 8.33692 11.5746 8.17773 11.3782 8.17773Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M21.3338 8.17773H20.6226C20.4263 8.17773 20.2671 8.33692 20.2671 8.53329V23.4666C20.2671 23.663 20.4263 23.8222 20.6226 23.8222H21.3338C21.5301 23.8222 21.6893 23.663 21.6893 23.4666V8.53329C21.6893 8.33692 21.5301 8.17773 21.3338 8.17773Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M16.356 5.3335H15.6449C15.4485 5.3335 15.2893 5.49268 15.2893 5.68905V26.3113C15.2893 26.5076 15.4485 26.6668 15.6449 26.6668H16.356C16.5523 26.6668 16.7115 26.5076 16.7115 26.3113V5.68905C16.7115 5.49268 16.5523 5.3335 16.356 5.3335Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
        </Icon>
    );
};
